{
  "devDependencies": {
    "@types/express": "^4.17.21",
    "@types/node": "^20.14.6",
    "@typescript-eslint/eslint-plugin": "^7.13.1",
    "@typescript-eslint/parser": "^7.13.1",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "globals": "^15.6.0",
    "prettier": "3.3.2",
    "ts-node": "^10.9.2",
    "tsup": "^8.2.2",
    "typescript": "^5.4.5",
    "typescript-eslint": "^7.13.1",
    "vitest": "^1.6.0"
  },
  "name": "@cortexclick/cortex",
  "repository": {
    "url": "https://github.com/cortexclick/cortex-sdk",
    "type": "git"
  },
  "version": "0.0.14",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist",
    "src"
  ],
  "scripts": {
    "build": "tsup",
    "clean": "rm -rf dist",
    "lint": "prettier --list-different . && eslint . --ext .ts || exit 1",
    "lint-fix": "prettier --write . && eslint . --ext .ts --fix",
    "dev": "node --watch -r ts-node/register index.ts",
    "run": "npm run build && node index.js",
    "test": "vitest",
    "test:package:dev": "npm run build && pulumi env run cortexclick/default/npm-test node ./test-package.js",
    "test:package:ci": "npm run build && node ./test-package.js",
    "test:fast": "vitest run --exclude src/content.test.ts",
    "test:dev": "CORTEX_API_URL=http://localhost:3001 pulumi env run cortexclick/default/npm-test npm run test",
    "test:ci": "vitest run",
    "test:prod": "pulumi env run npm-test npm run test",
    "test:fast:dev": "CORTEX_API_URL=http://localhost:3001 pulumi env run cortexclick/default/npm-test npm run test:fast",
    "test:fast:prod": "pulumi env run cortexclick/default/npm-test npm run test:fast",
    "test:indexers:dev": "CORTEX_API_URL=http://localhost:3001 pulumi env run cortexclick/default/npm-test vitest indexers.test.ts",
    "test:scraping:dev": "RUN_SCRAPER_TESTS=true CORTEX_API_URL=https://api-dev.cortexclick.com pulumi env run cortexclick/default/npm-test vitest scraping.test.ts",
    "test:scraping:prod": "RUN_SCRAPER_TESTS=true CORTEX_API_URL=https://api.cortexclick.com pulumi env run cortexclick/default/npm-test vitest scraping.test.ts"
  },
  "keywords": [],
  "author": "",
  "license": "Apache-2.0",
  "description": "",
  "dependencies": {
    "form-data": "^4.0.0"
  }
}
